import { eHinhThucGiangActionsObj } from "../../action-types/category/IHinhThucGiangActions";
import { generateActions } from "../generateActions";

export const hinhThucGiangActions = {
    ...generateActions(eHinhThucGiangActionsObj, "HINH_THUC_GIANG"),
};